import { render } from "./MentorsRecords.vue?vue&type=template&id=58c2b52b&scoped=true"
import script from "./MentorsRecords.vue?vue&type=script&lang=js"
export * from "./MentorsRecords.vue?vue&type=script&lang=js"

import "./MentorsRecords.vue?vue&type=style&index=0&id=58c2b52b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3444732531/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c2b52b"]])

export default __exports__